"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview18_exports = {};
__export(GeodesPreview18_exports, {
  default: () => GeodesPreview18_default
});
module.exports = __toCommonJS(GeodesPreview18_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.92578 12.1836C6.13151 12.1836 5.45443 12.4635 4.89453 13.0234C4.34766 13.5703 4.07422 14.2344 4.07422 15.0156V16.5195C4.07422 16.6497 4.02214 16.7669 3.91797 16.8711C3.82682 16.9622 3.71615 17.0078 3.58594 17.0078C3.44271 17.0078 3.31901 16.9622 3.21484 16.8711C3.1237 16.7669 3.07812 16.6497 3.07812 16.5195V15.0156C3.07812 14.4818 3.18229 13.987 3.39062 13.5312C3.58594 13.0625 3.85286 12.6589 4.19141 12.3203C4.54297 11.9688 4.95312 11.6888 5.42188 11.4805C5.89062 11.2852 6.39193 11.1875 6.92578 11.1875H11.3398C11.4701 11.1875 11.5807 11.2396 11.6719 11.3438C11.776 11.4349 11.8281 11.5456 11.8281 11.6758C11.8281 11.819 11.776 11.9427 11.6719 12.0469C11.5807 12.138 11.4701 12.1836 11.3398 12.1836H6.92578ZM9.42578 8.49219C8.77474 8.49219 8.22135 8.26432 7.76562 7.80859C7.3099 7.35286 7.08203 6.80599 7.08203 6.16797C7.08203 5.51693 7.3099 4.96354 7.76562 4.50781C8.22135 4.05208 8.77474 3.82422 9.42578 3.82422C10.0638 3.82422 10.6107 4.05208 11.0664 4.50781C11.5221 4.96354 11.75 5.51693 11.75 6.16797C11.75 6.80599 11.5221 7.35286 11.0664 7.80859C10.6107 8.26432 10.0638 8.49219 9.42578 8.49219ZM9.42578 9.50781C10.3372 9.50781 11.1185 9.18229 11.7695 8.53125C12.4206 7.88021 12.7461 7.09245 12.7461 6.16797C12.7461 5.24349 12.4206 4.45573 11.7695 3.80469C11.1185 3.15365 10.3372 2.82812 9.42578 2.82812C8.5013 2.82812 7.71354 3.15365 7.0625 3.80469C6.41146 4.45573 6.08594 5.24349 6.08594 6.16797C6.08594 7.09245 6.41146 7.88021 7.0625 8.53125C7.71354 9.18229 8.5013 9.50781 9.42578 9.50781ZM15.5 9.74219C15.6432 9.74219 15.7604 9.79427 15.8516 9.89844C15.9557 9.98958 16.0078 10.1068 16.0078 10.25V13.8047C16.0078 13.9349 15.9557 14.0521 15.8516 14.1562C15.7604 14.2474 15.6432 14.293 15.5 14.293H12.668V16.9102C12.668 17.0534 12.6159 17.1771 12.5117 17.2812C12.4206 17.3724 12.3034 17.418 12.1602 17.418C12.0299 17.418 11.9128 17.3724 11.8086 17.2812C11.7174 17.1771 11.6719 17.0534 11.6719 16.9102V13.8047C11.6719 13.7266 11.6849 13.6615 11.7109 13.6094C11.737 13.5443 11.7695 13.4857 11.8086 13.4336C11.8607 13.3945 11.9128 13.362 11.9648 13.3359C12.0299 13.3099 12.0951 13.2969 12.1602 13.2969H14.9922V10.25C14.9922 10.1068 15.0378 9.98958 15.1289 9.89844C15.2331 9.79427 15.3568 9.74219 15.5 9.74219ZM15.1484 9.05859C15.2396 8.96745 15.3568 8.92188 15.5 8.92188C15.6432 8.92188 15.7604 8.96745 15.8516 9.05859L17.5117 10.7383C17.6159 10.8294 17.668 10.9466 17.668 11.0898C17.668 11.2201 17.6159 11.3372 17.5117 11.4414C17.4206 11.5326 17.3034 11.5781 17.1602 11.5781C17.0299 11.5781 16.9128 11.5326 16.8086 11.4414L15.5 10.1328L14.1914 11.4414C14.0872 11.5326 13.9635 11.5781 13.8203 11.5781C13.6901 11.5781 13.5794 11.5326 13.4883 11.4414C13.3841 11.3372 13.332 11.2201 13.332 11.0898C13.332 10.9466 13.3841 10.8294 13.4883 10.7383L15.1484 9.05859Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview18 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview18_default = SvgGeodesPreview18;
